import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import ReferenceDetail from './pages/ReferenceDetail';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="om-os" element={<About />} />
        <Route path="referencer/:slug" element={<ReferenceDetail />} />
      </Route>
    </Routes>
  );
};

export default App;
